import React from 'react'
import type { ComponentPropsWithoutRef } from 'react'
import classNames from 'classnames'
import style from './style.module.scss'
import { Text } from '@crossfit/design-system'

type Props = ComponentPropsWithoutRef<'div'> & {
  label: string
  desc?: string
}

function Edit(props: Props) {
  const { label, children } = props

  return (
    <div className={style.wrapper}>
      <div className={classNames(style.col)}>
        <Text as='div' className={style.label} type='body' size='sm'>
          {label}
        </Text>
      </div>
      <div className={style.col}>
        {props.desc && (
          <Text type='body' size='sm' className={style.desc} bold>
            {props.desc}
          </Text>
        )}
        {children}
      </div>
    </div>
  )
}

export default Edit
